import React, { useState, useEffect, useCallback } from "react";
import { InnerSearch } from "../components/search/InnerSearch";
import { Accordion, AccordionTab } from "primereact/accordion";
import axios from "axios";
import "./Tickets.scss";
import { useSearchParams } from "react-router-dom";
const innerSearch = {
  pageName: "My Tickets",
  backSteps: "",
  breadcrumb: [
    {
      label: "Home",
      url: "/VZYSupport/helpSupport",
    },
    { label: "My Tickets" },
  ],
};

const decodeHtml = (html = "") => {
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};

export const Tickets = () => {
  const apiBaseURL = process.env.REACT_APP_API_URL || window.location.origin;
  const [tickets, setTickets] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openAttachments, setOpenAttachments] = useState({});
  const [searchParams] = useSearchParams();
  const REDIRECT_URL = "https://vzy.one/en/account";
  useEffect(() => {
    const urlToken = searchParams.get("a_t");
    const urlSid = searchParams.get("sid");
    const urlMno = searchParams.get("mno");

    const storedData = JSON.parse(
      sessionStorage.getItem("helpSupportData") || "{}",
    );
    if (urlToken && urlSid && urlMno) {
      sessionStorage.setItem(
        "helpSupportData",
        JSON.stringify({
          token: urlToken,
          sid: urlSid,
          mno: urlMno,
        }),
      );
      return;
    }
    const isTokenEmpty = !storedData?.token?.trim();
    const isSidEmpty = !storedData?.sid?.trim();
    const isSidZero = Number(storedData?.sid?.trim()) === 0;
    const isMnoEmpty = !storedData?.mno?.trim();
    if (isTokenEmpty || isSidEmpty || isMnoEmpty || isSidZero) {
      window.location.replace(REDIRECT_URL);
    }
  }, [searchParams]);
  const fetchTicketList = useCallback(async () => {
    try {
      setLoading(true);

      const payload = {
        OttSMSId: JSON.parse(sessionStorage.getItem("helpSupportData") || "{}")
          .sid,
        // OttSMSId: "108741425",
      };

      const response = await axios.post(
        `${apiBaseURL}/api/v1/ContactUs/vzy-complain`,
        payload,
        { headers: { "Content-Type": "application/json" } },
      );

      const apiData = response?.data?.data || [];

      const formattedTickets = apiData.map((item) => {
        const [date, time] = item.complainDate?.split(" ") || [];

        return {
          id: item.complainID,
          ticketId: item.complainID,
          categoryName: item.category,
          subCategory: item.subCategory,
          description: decodeHtml(item.complainDetails),
          date,
          time,
          status: item.status,
          email: item.emailId,
          mobileNumber: item.mobileNo,
          attachments: item.linkURL ? [item.linkURL] : [],
        };
      });

      setTickets(formattedTickets);
    } catch (err) {
      console.error("fetchTicketList error:", err);
    } finally {
      setLoading(false);
    }
  }, [apiBaseURL]);

  useEffect(() => {
    fetchTicketList();
  }, [fetchTicketList]);

  const toggleAttachments = (ticketId) => {
    setOpenAttachments((prev) => ({
      ...prev,
      [ticketId]: !prev[ticketId],
    }));
  };

  const getStatusClass = (status = "") => {
    switch (status.toLowerCase()) {
      case "open":
        return "status-open";
      case "in progress":
        return "status-in-progress";
      case "resolved":
        return "status-resolved";
      case "closed":
        return "status-closed";
      default:
        return "status-default";
    }
  };

  const renderTicketHeader = (ticket) => (
    <div className="ticket-header-wrapper">
      <div className="ticket-header-left">
        <h3 className="ticket-category-name">{ticket.categoryName}</h3>

        <div className="ticket-meta-info">
          <div className="ticket-id-label">Ticket ID: {ticket.ticketId}</div>
          <div className="ticket-datetime">
            {ticket.date} {ticket.time && `| ${ticket.time}`}
          </div>
        </div>
      </div>

      <div className="ticket-header-right">
        <span className={`ticket-status ${getStatusClass(ticket.status)}`}>
          {ticket.status}
        </span>
        <i className="pi pi-chevron-down chevron-icon" />
      </div>
    </div>
  );

  const renderTicketContent = (ticket) => (
    <div className="ticket-content-wrapper">
      <div className="ticket-details-section">
        <div className="ticket-content-row">
          <div className="ticket-col1">
            <label>Email:</label>
            <p>{ticket.email}</p>
          </div>

          <div className="ticket-col1">
            <label>Mobile Number:</label>
            <p>{ticket.mobileNumber}</p>
          </div>
          <div className="ticket-col1">
            <label>Category:</label>
            <p>{ticket.categoryName}</p>
          </div>

          <div className="ticket-col1">
            <label>Subject:</label>
            <p>{ticket.subCategory}</p>
          </div>
        </div>

        <div className="detail-full">
          <label>Description:</label>
          <div
            className="html-wraper"
            dangerouslySetInnerHTML={{ __html: ticket.description }}
          />
        </div>

        {ticket.attachments.length > 0 && (
          <div className="ticket-attachment">
            <button type="button" onClick={() => toggleAttachments(ticket.id)}>
              {ticket.attachments.length} Image added{" "}
              <i className="pi pi-chevron-down chevron-icon" />
            </button>

            {openAttachments[ticket.id] &&
              ticket.attachments.map((img, index) => (
                <img key={index} src={img} alt={`${index + 1} Images added`} />
              ))}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <>
      <InnerSearch innerSearch={innerSearch} />

      <section className="inner-page-details">
        <div className="container">
          <div className="tickets-container">
            {loading ? (
              <div className="tickets-loader">
                <p style={{ textAlign: "center" }}>Loading Tickets...</p>
              </div>
            ) : tickets.length > 0 ? (
              <Accordion
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
                className="tickets-accordion"
              >
                {tickets.map((ticket) => (
                  <AccordionTab
                    key={ticket.id}
                    header={renderTicketHeader(ticket)}
                  >
                    {renderTicketContent(ticket)}
                  </AccordionTab>
                ))}
              </Accordion>
            ) : (
              <div className="no-tickets">
                <p>No tickets found</p>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};
